<template>
  <main>
    <Splitter>
      <SplitterPanel :size="25">
        <div>
          <HelpAdd @visible="getAllHelpsName" />
        </div>
        <Card class="w-100">
          <template #title>Aides texte</template>
          <template #content>
            <!-- <Menu :model="items" /> -->
            <!-- <div
              v-for="(item, index) in sorted(helps)"
              :key="index"
              class="mb-1"
            > -->
            <div v-for="(item, index) in helps" :key="index" class="mb-1">
             
              <Button @click="selectedHelp(item)">{{
                item.number + " - " + (item.label ? item.label : item.name)
              }}</Button>

              <HelpEdit :helpToEdit="item" @edit="item = $event"  />
              <Button
                @click="removeHelp(item.id)"
                icon="pi pi-times"
                aria-label="Submit"
                class="p-button-danger"
                outlined
              />

            </div>
          </template>
        </Card>
      </SplitterPanel>
      <SplitterPanel :size="75">
        <Card class="m-1 w-100">
          <template #title> </template>
          <template #content>
            <HelpManage
              v-if="selected.id"
              :helpId="selected.id"
              :selected="selected"
            />
          </template>
        </Card>
      </SplitterPanel>
    </Splitter>
  </main>
</template>

<script>
import HelpManage from "./HelpManage.vue";
import HelpAdd from "./HelpAdd.vue";
import HelpEdit from "./HelpEdit.vue";
// import { ApiService } from "./services/ApiService";

export default {
  data() {
    return {
      helps: [],
      helpToEdit: null,
      selected: {},
      visible: false,
    };
  },
  components: {
    HelpManage,
    HelpAdd,
    HelpEdit,
  },
  mounted() {
    this.getAllHelpsName();
  },
  methods: {
    openEditHelp(help) {
      this.helpToEdit = help;
      this.visible = true;
    },

    emitVisible() {
      this.visible = false;
    },
    async getAllHelpsName() {
      // ApiService.getAllHelpsName().then((data) => {
      //   this.helps = data;
      // });
      try {
        const resp = await fetch(
          process.env.VUE_APP_API_BASE_URL + "/api/v1/helps/getAllHelpsName",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.localStorage.token}`,
            },
          }
        );
        // console.log(await resp.json());
        const json = await resp.json();
        console.log(json);
        this.helps = json;
      } catch (error) {
        console.log(error);
      }
    },

    selectedHelp(select) {
      console.log(select);
      
      this.selected = select;
    },

    async removeHelp(helpId) {
      console.log(helpId);
      if (window.confirm("Etes-vous sûr de vouloir supprimer cet élément ?")) {
        // await ApiService.removeHelp(helpId);
        try {
          await fetch(
            process.env.VUE_APP_API_BASE_URL + "/api/v1/helps/removeHelp",
            {
              method: "POST",
              body: JSON.stringify({ helpId }),
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${this.localStorage.token}`,
              },
            }
          );
        } catch (error) {
          console.log(error);
        }
        this.getAllHelpsName();
      }
    },

    sorted(array) {
      return array.sort((a, b) => a.number - b.number);
    },
  },
};
</script>

<style></style>
